export default "__VITE_ASSET__Dczywk2J__"